export const breakpoints = {
  mobile: `(max-width: ${'760px'})`,
  tablet: `(max-width: ${'1024px'})`,
  laptop: `(max-width: ${'1280px'})`,
  laptopL: `(max-width: ${'1440px'})`,
  desktop: `(max-width: ${'1560px'})`,
  desktopL: `(max-width: ${'1920px'})`,
}
